<template>
  <div v-loading="$wait.waiting(_uid)">
    <div>
      <div v-if="isListing" class="mt-s">
        <div class="text-right control-button-wrapper pt-xxs">
          <acl :roles="canNewEvent()">
            <button
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="changeAction(CREATE_ACTION)"
            >
              New
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
        </div>

        <el-tabs :value="activeTab" @tab-click="selectTab">
          <el-tab-pane label="All" name="all">
            <div v-if="matchTab('all')">
              <EventTable :data="activeList" @eventShow="handleShow" />
            </div>
          </el-tab-pane>

          <el-tab-pane label="Archived" name="archived">
            <div v-if="matchTab('archived')">
              <EventTable :data="archivedList" @eventShow="handleShow" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div>
      <div v-if="isCreating" class="mt-s">
        <div class="text-right control-button-wrapper pt-xxs">
          <button
            type="button"
            class="btn btn-cancel btn-primary btn-wd"
            @click="changeAction(LIST_ACTION)"
          >
            Back
          </button>
          <acl :roles="canCreateEvent()">
            <button
              type="button"
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="handleCreate"
            >
              Create
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
        </div>

        <EventForm :event="eventCreate" />
      </div>
    </div>

    <div>
      <div v-if="isShowing" class="mt-s">
        <div class="text-right control-button-wrapper pt-xxs">
          <button
            type="button"
            class="btn btn-primary btn-wd mr-5"
            @click="changeAction(LIST_ACTION)"
          >
            Back
          </button>

          <acl :roles="canActivateEvent()">
            <button
              v-show="!event.is_active"
              type="button"
              class="btn btn-success btn-wd mr-5"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="handleActivateEvent"
            >
              Restore
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>

          <acl :roles="canDeactivateEvent()">
            <button
              v-show="event.is_active"
              type="button"
              class="btn btn-danger btn-wd mr-5"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="handleDeactivateEvent"
            >
              Archive
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>

          <acl :roles="canEditEvent()">
            <button
              v-show="event.is_active"
              type="button"
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="changeAction(UPDATE_ACTION)"
            >
              Edit
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
        </div>

        <EventShow :event="event" @eventDownloadFile="handleDownloadFile" />
      </div>
    </div>

    <div>
      <div v-if="isUpdating" class="mt-s">
        <div class="text-right control-button-wrapper pt-xxs">
          <acl :roles="canDeleteEvent()">
            <button
              type="button"
              class="btn btn-danger btn-wd submit-button"
              @click="handleDeleteEvent"
            >
              Delete
            </button>
          </acl>
          <button
            type="button"
            class="btn btn-cancel btn-primary btn-wd"
            @click="changeAction(SHOW_ACTION)"
          >
            Cancel
          </button>

          <acl :roles="canActivateEvent()">
            <button
              v-show="!event.is_active"
              type="button"
              class="btn btn-success btn-wd mr-5"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="handleActivateEvent"
            >
              Restore
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
          <acl :roles="canDeactivateEvent()">
            <button
              v-show="event.is_active"
              type="button"
              class="btn btn-danger btn-wd mr-5"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="handleDeactivateEvent"
            >
              Archive
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
          <acl :roles="canUpdateEvent()">
            <button
              v-show="event.is_active"
              type="submit"
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="handleUpdate"
            >
              Update
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
        </div>
        <EventForm :event="eventUpdate" @eventDeleteFile="handleDeleteFile" />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import EventTable from "@components/Events/Components/Table.vue";
import EventShow from "@components/Events/Components/Show.vue";
import EventForm from "@components/Events/Components/Form.vue";
import UserService from "@app/services/users";
import swal from "sweetalert2";
import _cloneDeep from "lodash.clonedeep";
import rolesConstants from "@/components/acl/roles";
import { getStorageData } from "@/utils/storage";
import parseSettings from "@providers/parseSettings";
import EventBus from "@app/utils/event-bus";

Vue.use(Loading.directive);

const actionList = {
  CREATE_ACTION: 1,
  UPDATE_ACTION: 2,
  SHOW_ACTION: 3,
  LIST_ACTION: 4,
};

export default {
  components: {
    EventTable,
    EventShow,
    EventForm,
  },
  emits: ["eventShow"],
  data() {
    return {
      activeTab: "all",
      action: null,
      activeList: [],
      archivedList: [],
      event: {},
      eventCreate: {},
      eventUpdate: {},
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyUserStore", ["user"]),
    ...mapGetters("companyStore", { company: "currentCompany" }),
    routeParams() {
      return this.$route.params;
    },
    routeQuery() {
      return this.$route.query;
    },
    isListing() {
      return this.action === this.LIST_ACTION;
    },
    isShowing() {
      return this.action === this.SHOW_ACTION;
    },
    isCreating() {
      return this.action === this.CREATE_ACTION;
    },
    isUpdating() {
      return this.action === this.UPDATE_ACTION;
    },
  },
  beforeCreate() {
    EventBus.DownloadProgressBar.$on("onDownloadProgress", (data) => {
      console.log(data);
      this.$Progress.set(data.progress);
    });
  },
  created() {
    this.CREATE_ACTION = actionList.CREATE_ACTION;
    this.UPDATE_ACTION = actionList.UPDATE_ACTION;
    this.SHOW_ACTION = actionList.SHOW_ACTION;
    this.LIST_ACTION = actionList.LIST_ACTION;
    this.ROLE_SUPER = rolesConstants.ROLE_SUPER;
    this.ROLE_ADMIN = rolesConstants.ROLE_ADMIN;
    this.ROLE_COMPANY_MANAGER = rolesConstants.ROLE_COMPANY_MANAGER;
    this.ROLE_TRAINING_MANAGER = rolesConstants.ROLE_TRAINING_MANAGER;
    this.ROLE_TRAINEE = rolesConstants.ROLE_TRAINEE;
    this.ROLE_SUPPORT = rolesConstants.ROLE_SUPPORT;
    this.ROLE_CTOPS = rolesConstants.ROLE_CTOPS;
  },
  mounted() {
    if (this.routeQuery.eventId == null) {
      this.getList();
      this.changeAction(this.LIST_ACTION);
      return;
    }

    return this.handleShow({ id: this.routeQuery.eventId });
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseSettings,
    selectTab({ paneName }) {
      if (!paneName) {
        return (this.activeTab = "all");
      }
      this.activeTab = paneName;
    },
    matchTab(pane) {
      return this.activeTab === pane;
    },
    async getList() {
      try {
        this.$wait.start(this._uid);
        const list = await UserService.getEvents(this.company.id, this.user.id);

        this.activeList = list.filter(function (events) {
          return events.is_active;
        });

        this.archivedList = list.filter(function (events) {
          return !events.is_active;
        });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
      return;
    },
    canNewEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);

      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    canCreateEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);

      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    canEditEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);

      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    canActivateEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);
      
      return roleList;
    },
    canDeactivateEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);
      
      return roleList;
    },
    canDeleteEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);

      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    canUpdateEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);

      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    getPrestine() {
      return {
        description: null,
        notes: null,
        issued_at: null,
        expiry_at: null,
        files: [],
        attachments: [],
        manager: null,
        trainee: null,
        reminders: [
          { key: "days", value: "0" },
          { key: "days", value: "0" },
          { key: "days", value: "0" },
        ],
      };
    },
    changeAction(action) {
      if (action === this.CREATE_ACTION) {
        this.eventCreate = this.getPrestine();
      }

      if (action === this.UPDATE_ACTION) {
        this.eventUpdate = this.prepareUpdate();
      }

      if (action === this.LIST_ACTION) {
        this.getList();
      }

      this.action = action;
    },
    prepareUpdate() {
      const event = _cloneDeep(this.event);

      event.attachments = event.files;
      event.files = [];

      const defaultReminders = this.getPrestine().reminders;

      if (!event.reminders.length) {
        event.reminders = defaultReminders;
      }

      const reminderCount = event.reminders.length;
      const defaultReminderCount = defaultReminders.length;
      const missingCount = defaultReminderCount - reminderCount;

      if (missingCount > 0) {
        const toAdd = defaultReminders.splice(0, missingCount);
        event.reminders = [...event.reminders, ...toAdd];
      }

      return event;
    },
    async handleShow(data) {
      try {
        this.$wait.start(this._uid);
        const event = await UserService.showEvent(
          this.company.id,
          this.user.id,
          data.id
        );

        this.event = event;
      } catch (error) {
        this.addNewError(error);
        this.changeAction(this.LIST_ACTION);
      } finally {
        this.changeAction(this.SHOW_ACTION);
        this.$wait.end(this._uid);
      }
    },
    async handleCreate() {
      try {
        this.$wait.start(this._uid);

        const event = await UserService.storeEvent(
          this.company.id,
          this.user.id,
          this.eventCreate
        );

        this.$notify({
          message: "Data updated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.event = event;
        this.activeList.push(event);
        this.changeAction(this.SHOW_ACTION);
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async handleDownloadFile({ event, file }) {
      try {
        this.$wait.start(this._uid);
        const response = await UserService.downloadFile(
          this.company.id,
          this.user.id,
          event.id,
          file.id
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.original_name);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.$Progress.fail();
        this.addNewError(error);
      } finally {
        this.$Progress.finish();
        this.$wait.end(this._uid);
      }
    },
    async handleUpdate() {
      try {
        this.$wait.start(this._uid);

        delete this.eventUpdate.attachments;

        const event = await UserService.updateEvent(
          this.company.id,
          this.user.id,
          this.eventUpdate
        );

        this.$notify({
          message: "Data updated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.event = event;

        this.changeAction(this.SHOW_ACTION);
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async handleDeleteEvent() {
      try {
        this.$wait.start(this._uid);

        const shouldDelete = await swal({
          title: "Confirmation",
          text: "Do you really want to delete this event?",
          type: "warning",
          buttonsStyling: false,
          reverseButtons: true,
          confirmButtonClass: "btn ml-xs btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          showCancelButton: true,
        });

        if (!shouldDelete) {
          return;
        }

        await UserService.deleteEvent(
          this.company.id,
          this.user.id,
          this.event.id
        );

        this.$notify({
          message: "Event deleted successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        const index = this.activeList.findIndex(
          ({ id: cardId }) => this.event.id === cardId
        );
        this.activeList.splice(index, 1);
        this.changeAction(this.LIST_ACTION);
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async handleActivateEvent() {
      try {
        this.$wait.start(this._uid);

        const event = await UserService.activateEvent(
          this.company.id,
          this.user.id,
          this.event.id
        );

        this.$notify({
          message: "Event activated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.event = event;
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async handleDeactivateEvent() {
      try {
        this.$wait.start(this._uid);

        const event = await UserService.deactivateEvent(
          this.company.id,
          this.user.id,
          this.event.id
        );

        this.$notify({
          message: "Event deactivated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.event = event;
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async handleDeleteFile({ event, file }) {
      try {
        this.$wait.start(this._uid);

        const shouldDelete = await swal({
          title: "Confirmation",
          text: "Do you really want to delete this file?",
          type: "warning",
          buttonsStyling: false,
          reverseButtons: true,
          confirmButtonClass: "btn ml-xs btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          showCancelButton: true,
        });

        if (!shouldDelete) {
          return;
        }

        await UserService.deleteFile(
          this.company.id,
          this.user.id,
          event.id,
          file.id
        );

        //SHOW ACTION
        const fileList = this.event.files;
        const index = fileList.findIndex(
          ({ id: cardId }) => file.id === cardId
        );
        fileList.splice(index, 1);

        //UPDATE ACTION
        this.eventUpdate = this.prepareUpdate();
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style lang="scss"></style>
